import { dateToMysql, dateToShow } from '@/helpers/dates'
import { success } from '@/utils/alert'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

const showMonthYear = date => {
  if (!date) {
    return null
  }
  return moment(date, 'YYYYMM').format('MM/YYYY')
}

const mysqlMonthYear = date => {
  if (!date) {
    return null
  }
  return moment(date, 'MM/YYYY').format('YYYYMM')
}

const prepareSave = function (specialization) {
  if (isEmpty(specialization.attachment.content)) {
    delete specialization.attachment
  }

  specialization.issuance_date = dateToMysql(specialization.issuance_date)
  if (this.isTitleOfSpecialization) {
    specialization.area = null
    specialization.start = null
    specialization.end = null
  } else {
    specialization.start = mysqlMonthYear(specialization.start)
    specialization.end = mysqlMonthYear(specialization.end)
  }

  return specialization
}

const prepareShow = specialization => {
  specialization.issuance_date = dateToShow(specialization.issuance_date)
  specialization.start = showMonthYear(specialization.start)
  specialization.end = showMonthYear(specialization.end)

  return specialization
}

export default {
  ...mapActions(['loadProfessional']),
  prepareShow,
  prepareSave,
  setTypeSpecialization (type) {
    this.type_specialization = type
  },
  afterCreated () {
    success('Especialização incluida com sucesso!')
  },
  afterUpdated () {
    success('Especialização alterada com sucesso.')
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/form/resources/methods.js